import {request} from "../utils/request";
import {fetchPlatform, fetchProduct} from "../index";

/**
 * Fetches outstanding tickets for a specific location
 *
 * @return {Promise<unknown>}
 */
export async function fetchOutstandingTickets() {
  return request("tickets", "GET");
}

/**
 *
 * @param ticket
 * @return {Promise<unknown>}
 */
export async function fetchTicket(ticket) {
  return request("tickets/" + ticket, "GET");
}

/**
 * Sends a ticket to the ticket screen
 *
 * @param ticket
 * @return {Promise<Promise<unknown> | Promise<unknown>>}
 */
export async function sendTicket(ticket) {
  return request("tickets/" + ticket, "POST", {});
}

/**
 * Combines the putItems and sendTicket into one request
 *
 * Puts multiple items and discounts, then sends the ticket to the ticket screen
 *
 * @param ticket
 * @return {Promise<Promise<unknown> | Promise<unknown>>}
 */
export async function saveTicket(ticket, items, discounts) {
  return request("tickets/" + ticket, "PUT", {
    ITEMS: items,
    DISCOUNTS: discounts,
  });
}

/**
 *
 * @param ticket
 * @param params
 *
 * @return {Promise<void>}
 */
export async function updateTicket(ticket, params) {
  return request("tickets/" + ticket, "PATCH", params);
}

/**
 *
 * @param ticket
 * @return {Promise<unknown>}
 */
export async function fetchTicketEvents(ticket) {
  return request("tickets/" + ticket + "/events", "GET");
}

/**
 *
 * @param params
 * @param params.NAME                                                 Ticket Name
 * @param params.PHONE                                                Ticket Phone
 * @param params.TICKET_TYPE                                          Ticket type, need to write script to auto
 *   generate this for the boys but now just use 1 lol
 *
 * @param {{TYPE: String, AMOUNT, CONTENT}[]} params.SOURCES          Sources needed for payment
 * @param {{NAME: Number, PRODUCT_ID: String, QUANTITY: Array, SELECTIONS, AMOUNT_DISCOUNT,AMOUNT_REFUND, AMOUNT_TAX,
 *   AMOUNT, TOTAL, NOTES  }[]} params.ITEMS                          Ticket Items
 *
 * @return {Promise<void>}
 */
export async function generateTicket(params) {
  return request("tickets", "POST", {
    ...params,
    TYPE: fetchProduct(),
    PLATFORM: fetchPlatform(),
  });
}

/**
 * Process a ticket w/ payments and the ability to change with extra params
 *
 * @param ticket                                                       The ticket string
 * @param {{TYPE: String, AMOUNT, CONTENT}[]} payments         Sources needed for payment
 *
 * @return {Promise<void>}
 */
export async function processTicket(ticket, payments) {
  return request("tickets/" + ticket + "/process", "POST", {SOURCES: payments});
}

/**
 * @param ticket
 * @param {{NAME: Number, PRODUCT_ID: String, QUANTITY: Array, SELECTIONS, AMOUNT_DISCOUNT,AMOUNT_REFUND, AMOUNT_TAX,
 *   AMOUNT, TOTAL, NOTES  }[]} params
 *
 * @return {Promise<void>}
 */
export async function appendItems(ticket, params) {
  return request("tickets/" + ticket + "/items", "POST", [params]);
}

/**
 *
 * @param ticket
 * @param params
 * @param params.NAME
 * @param params.PRODUCT_ID
 * @param params.QUANTITY
 * @param params.SELECTIONS {{DOG: String}[]}
 * @param params.AMOUNT_DISCOUNT
 * @param params.AMOUNT_REFUND
 * @param params.AMOUNT_TAX
 * @param params.AMOUNT
 * @param params.TOTAL
 * @param params.NOTES
 *
 * @return {Promise<void>}
 */
export async function appendItem(ticket, params) {
  return request("tickets/" + ticket + "/items", "POST", {ITEMS: [params]});
}

/**
 * Puts multiple items into a ticket
 *
 * @param ticket
 * @param params
 * @return {Promise<Promise<unknown> | Promise<unknown>>}
 */
export async function putItems(ticket, items) {
  return request("tickets/" + ticket + "/items", "PUT", {ITEMS: items});
}

/**
 * Puts multiple items and discounts
 *
 * @param ticket
 * @param params
 * @return {Promise<Promise<unknown> | Promise<unknown>>}
 */
export async function putItemsAndDiscounts(ticket, items, discounts) {
  return request("tickets/" + ticket + "/items/discounts", "PUT", {
    ITEMS: items,
    DISCOUNTS: discounts,
  });
}

/**
 * Add products to a ticket after creating it
 *
 * @param ticket
 *
 * @return {Promise<void>}
 */
export async function appendTicket(ticket) {}

export async function modifyTicket(ticket, params) {}
